import { Fragment } from "react";

const DOW = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
const fmt = (d) => { const x = new Date(d); return `${DOW[x.getDay()]} ${x.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" })}`; };
const Diff = ({ v, testId }) => (
  <span className={`font-mono-num inline-block min-w-[3rem] rounded-md px-2 py-0.5 text-right font-bold ${v < 0 ? "bg-rose-100 text-rose-700" : "bg-emerald-50 text-emerald-700"}`} data-testid={testId}>{v > 0 ? `+${v}` : v}</span>
);

const groupWeeks = (days) => {
  const g = [];
  days.forEach((d) => {
    const last = g[g.length - 1];
    if (last && last.week === d.week) last.days.push(d); else g.push({ week: d.week, days: [d] });
  });
  return g;
};

export const ForecastTable = ({ days, isAdmin }) => {
  if (!days.length) return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center text-sm text-slate-500" data-testid="forecast-empty">
      Nessun forecast per questa stazione. {isAdmin ? "Carica il file FC (e il file Same Day per DLO3)." : "L'amministrazione deve caricare il file del forecast."}
    </div>
  );
  const hasSd = days.some((d) => d.sd);
  return (
    <div className="min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="forecast-table">
          <thead className="border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500 [&_th]:whitespace-nowrap [&_th]:px-3 [&_th]:py-2">
            <tr><th>Giorno</th><th className="text-right">Rotte FC</th>{hasSd && <th className="text-right">Same Day A</th>}<th className="text-right">Fabbisogno</th>
              <th className="text-right">Disponibili</th><th className="text-right">Disavanzo</th><th className="text-right">Rientri presunti</th><th className="text-right">Disavanzo con rientri</th></tr>
          </thead>
          <tbody>
            {groupWeeks(days).map((w) => {
              const peak = Math.max(...w.days.map((d) => d.need));
              const worst = Math.min(...w.days.map((d) => d.diff_returns));
              return (
                <Fragment key={w.week}>
                  <tr className="border-y bg-slate-900 text-white" data-testid={`forecast-week-${w.week}`}>
                    <td className="px-3 py-2 font-bold" colSpan={2}>Week {w.week}</td>
                    <td className="px-3 py-2 text-xs text-slate-300" colSpan={hasSd ? 6 : 5}>Picco fabbisogno <b className="text-white">{peak}</b> · disavanzo peggiore <b className={worst < 0 ? "text-rose-300" : "text-emerald-300"}>{worst > 0 ? `+${worst}` : worst}</b></td>
                  </tr>
                  {w.days.map((d) => (
                    <tr key={d.date} className={`border-b ${d.past ? "text-slate-400" : ""} ${d.need === peak && !d.past ? "bg-amber-50/60" : ""}`} data-testid={`forecast-day-${d.date}`}>
                      <td className="whitespace-nowrap px-3 py-2 font-medium">{fmt(d.date)}</td>
                      <td className="font-mono-num px-3 py-2 text-right">{d.fc}</td>
                      {hasSd && <td className="font-mono-num px-3 py-2 text-right">{d.sd || "—"}</td>}
                      <td className="font-mono-num px-3 py-2 text-right font-bold">{d.need}</td>
                      <td className="font-mono-num px-3 py-2 text-right">{d.available}</td>
                      <td className="px-3 py-2 text-right"><Diff v={d.diff} testId={`forecast-diff-${d.date}`} /></td>
                      <td className="font-mono-num px-3 py-2 text-right text-blue-700">{d.returns ? `+${d.returns}` : "—"}</td>
                      <td className="px-3 py-2 text-right"><Diff v={d.diff_returns} testId={`forecast-diffr-${d.date}`} /></td>
                    </tr>
                  ))}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="border-t px-3 py-2 text-xs text-slate-500">Fabbisogno = rotte FC senza bici{hasSd && " + Same Day ciclo A (il ciclo C usa i furgoni che rientrano)"}. Disponibili = furgoni disponibili oggi. Rientri presunti = furgoni fermi con data di rientro entro quel giorno.</p>
    </div>
  );
};
